// Mock data for MyDigitalAction Experience landing page

export const HERO = {
  eyebrow: "PERCORSO IN PRESENZA \u2014 PISA, MONTACCHIELLO CAMPUS",
  title_line1: "Il marketing della tua attivit\u00e0",
  title_line2: "lo paghi gi\u00e0.",
  title_line3: "\u00c8 ora che tu capisca davvero come funziona.",
  subtitle: "MyDigitalAction \u2014 Experience \u00e8 il percorso in presenza che in 4 giornate ti consegna un sistema digitale funzionante per la tua attivit\u00e0, costruito con il metodo che usiamo ogni giorno in agenzia.",
  tagline: "NESSUNA SLIDE INUTILE. NESSUN TEORICO CHE NON HA MAI GESTITO UN'AZIENDA. NESSUNA DELEGA ALLA CIECA.",
  ctaPrimary: "Iscriviti all'All-In Experience \u2014 \u20ac1.143",
  ctaSecondary: "Parla con un consulente",
  paymentNote: "Paghi anche in 3 rate da 381\u20ac senza interessi. Garanzia soddisfatto o rimborsato.",
};

export const PILLARS = [
  { title: "Formazione in presenza", desc: "35 ore in aula a Pisa, con esercitazioni pratiche." },
  { title: "Coaching One\u2011to\u2011One", desc: "3 sessioni personalizzate (6h totali) sul tuo progetto reale." },
  { title: "Laboratori pratici", desc: "Accesso illimitato ai lab settimanali su tool e AI." },
  { title: "Metodo testato in agenzia", desc: "Il metodo My Digital Action che usiamo ogni giorno." },
];

export const PROBLEMS = [
  "Hai pagato un\u2019agenzia per mesi senza capire cosa stesse facendo, senza risultati misurabili.",
  "Hai seguito corsi online pieni di teoria che, una volta tornato alla scrivania, non hai mai applicato.",
  "Gestisci i social \u201cquando riesci\u201d, senza un piano, senza sapere cosa funziona e cosa no.",
  "Hai sito, pagina Facebook, forse una newsletter\u2026 ma non comunicano tra loro e non generano clienti.",
];

export const METHOD_BENEFITS = [
  { key: "Impari", title: "Con metodo", desc: "Acquisisci tutte le competenze per gestire o delegare la tua comunicazione con consapevolezza." },
  { key: "Applichi", title: "Con supporto", desc: "In aula ricevi tutto il supporto necessario per applicare davvero le tecniche apprese." },
  { key: "Realizzi", title: "Il tuo progetto", desc: "Nelle sessioni one\u2011to\u2011one costruiamo insieme il tuo ecosistema digitale operativo." },
  { key: "Non sei", title: "Mai solo", desc: "Accesso ai laboratori mensili con focus sugli strumenti: mai pi\u00f9 confusione sui tool." },
];

export const ALL_IN = {
  code: "ALL\u2011IN EXPERIENCE",
  title: "Il tuo ecosistema digitale, guidato passo dopo passo.",
  hours: "35 ore in aula + 6 ore di coaching one\u2011to\u2011one",
  formats: [
    "4 giornate consecutive per un\u2019immersione completa",
    "1 corso a settimana, per una crescita costante",
    "1 corso al mese, se preferisci una progressione lenta",
    "Dal mercoled\u00ec al sabato, per completare in una settimana",
  ],
};

export const CORSI = [
  {
    n: "01",
    slug: "controlla-la-tua-comunicazione-digitale",
    wistiaId: "wi4w85s8we",
    title: "Controlla la tua Comunicazione Digitale",
    subtitle: "Il Metodo My Digital Action",
    hours: "9 ore in aula",
    goal: "Costruire un sistema completo di acquisizione e fidelizzazione clienti.",
    price: "260",
    originalPrice: "520",
    modules: [
      "Mappa MDA: acquisizione clienti online in 3 passi",
      "Incuriosire: messaggio differenziante e posizionamento",
      "Da Curioso a Interessato: contenuti e strategia",
      "Qualificare: email marketing e automazione",
      "Vendere: trasformare contatti in clienti",
      "Traffico web: generare visibilit\u00e0 e lead di qualit\u00e0",
    ],
  },
  {
    n: "02",
    slug: "social-media-marketing",
    wistiaId: "f9ahu5cpy6",
    videoCover: "/video-covers/social-media-marketing.jpg",
    title: "Social Media Marketing spiegato semplice",
    subtitle: "Comunicare con efficacia, senza tecnicismi",
    hours: "9 ore in aula",
    goal: "Comunicare con efficacia e attrarre clienti, anche senza competenze tecniche.",
    price: "260",
    originalPrice: "520",
    modules: [
      "Cos'\u00e8 il Social Media Marketing",
      "Analisi del Consumatore e Strategia Digitale",
      "Contenuti creativi e visivi",
      "Creare un Funnel di Marketing Digitale efficace",
      "Meta ADS Base \u2013 Facebook & Instagram",
    ],
  },
  {
    n: "03",
    slug: "facebook-advanced",
    urlSlug: "meta-ads-advanced",
    wistiaId: "cm9pe9d71n",
    videoCover: "/video-covers/facebook-advanced.jpg",
    title: "Meta Ads Advanced \u2013 Campagne professionali",
    subtitle: "Campagne strutturate, ottimizzate, scalabili",
    hours: "7 ore in aula",
    goal: "Creare campagne Meta Ads strutturate, ottimizzate, scalabili.",
    price: "260",
    originalPrice: "520",
    modules: [
      "Introduzione a Meta Ads 2.0",
      "Fondamenti del Business Manager",
      "Algoritmo e targeting intelligente",
      "Struttura Power 5 e automazioni",
      "Creativit\u00e0 e copywriting",
      "Budget, testing e scaling",
      "Lettura dei dati e analisi",
      "Strategie specifiche per settore",
      "Casi studio",
    ],
  },
  {
    n: "04",
    slug: "customer-loyalty",
    wistiaId: "w38toqmc5r",
    videoCover: "/video-covers/customer-loyalty.jpg",
    title: "Data\u2011Driven Loyalty & One\u2011Time Offer",
    subtitle: "Automatizzare la fidelizzazione",
    hours: "5 ore in aula",
    goal: "Automatizzare la fidelizzazione e massimizzare il valore cliente.",
    price: "260",
    originalPrice: "520",
    modules: [
      "Fondamenti del Database Marketing e CRM",
      "Programmi fedelt\u00e0 e automazioni",
      "Workflow di fidelizzazione con strategia OTO",
      "Integrazione offline e online",
      "Roadmap personalizzata",
      "Laboratorio pratico",
    ],
  },
  {
    n: "05",
    slug: "agenti-ai",
    wistiaId: "0dwh1c6j5v",
    videoCover: "/video-covers/agenti-ai.jpg",
    title: "Agenti AI in Azione",
    subtitle: "Automazione intelligente per il tuo business",
    hours: "5 ore in aula",
    goal: "Integrare l\u2019AI nel business per contenuti, processi e vendite.",
    price: "260",
    originalPrice: "520",
    modules: [
      "Introduzione agli Agenti AI",
      "AI per Marketing e Content Creation",
      "AI per Customer Care",
      "AI per Vendite e Up\u2011Sell",
      "Laboratorio e caso studio",
      "Normative, etica e futuro degli Agenti AI",
    ],
  },
];

// Resolve a course by its URL param (accepts internal slug or public urlSlug).
export const findCourse = (param) =>
  CORSI.find((c) => c.slug === param || c.urlSlug === param) || null;

// Build the public /corso URL for a course given its internal slug (or urlSlug).
export const courseUrl = (slugOrId) => {
  const c = findCourse(slugOrId);
  return `/corso/${(c && (c.urlSlug || c.slug)) || slugOrId}`;
};

export const COACHING = {
  title: "Coaching One\u2011to\u2011One",
  desc: "Alla fine di ogni corso avrai la possibilit\u00e0 di confrontarti con un nostro esperto per mettere a punto nella pratica il tuo progetto e lanciarlo definitivamente.",
  items: [
    "3 sessioni personalizzate da 2h con un nostro esperto",
    "Lavoriamo sul tuo caso reale",
    "Scegliamo e configuriamo gli strumenti giusti",
    "Installiamo insieme il tuo sistema digitale operativo",
    "Programmiamo il primo lancio insieme",
  ],
};

export const LABS = [
  { title: "Costruisci", desc: "Funnel, landing page ed email marketing su piattaforme all\u2011in\u2011one: Kajabi, GoHighLevel, Builderall, GetResponse." },
  { title: "Automatizza", desc: "Agenti AI per assistenza clienti, marketing e vendite in modo automatico, intelligente e personalizzato." },
  { title: "Collega", desc: "Semplifica il lavoro con automazioni tra strumenti usando Make, Zapier e altri tool no\u2011code." },
  { title: "Padroneggia", desc: "Supporto pratico per usare quei tool digitali che hai sempre evitato. Impari facendo." },
  { title: "Scrivi", desc: "AI generativa per creare testi persuasivi: email, landing page, annunci, in modo semplice." },
  { title: "Aggiornati", desc: "Ogni mese aggiornamenti pratici su AI, tool emergenti e strategie per restare un passo avanti." },
];

export const BONUSES = [
  { id: 1, tag: "BONUS 01", name: "Strategic Map", value: "49 \u20ac", desc: "La Mappa My Digital Action per avere sempre tutto sotto controllo." },
  { id: 2, tag: "BONUS 02", name: "Pro Marketing Kit", value: "97 \u20ac", desc: "4 guide cartacee premium con strategie applicabili a ogni attivit\u00e0." },
  { id: 3, tag: "BONUS 03", name: "Action Planner", value: "97 \u20ac", desc: "Workbook operativo + eserciziario da 90 pagine per costruire il tuo sistema passo passo." },
  { id: 4, tag: "BONUS 04", name: "Expert Sprint", value: "1.500 \u20ac", desc: "3 sessioni di coaching one\u2011to\u2011one (2h ciascuna) tecnico\u2011strategiche." },
  { id: 5, tag: "BONUS 05", name: "Tech Lab", value: "2.400 \u20ac", desc: "Accesso illimitato per 1 anno ai laboratori pratici settimanali su tool e automazioni no\u2011code." },
];

export const PRICING = {
  totalValue: "6.683 \u20ac",
  standard: "1.240",
  today: "1.143",
  vat: "iva esclusa",
  installments: "3 rate da 381\u20ac senza interessi con PayPal",
};

export const TESTIMONIALS = [
  { name: "Simona Adelaide Martini", role: "CEO di Psicoludìa", text: "Altissima competenza, professionalità e attenzione per i e le clienti. Segue da tempo la nostra società, Psicoludìa, e noi ne siamo entusiaste.", verified: true },
  { name: "Roberto Stufa", role: "Cliente Digital Formula", text: "Agenzia di web marketing professionale, composto da uno staff molto preparato. Ottimo il loro metodo di lavoro nell'approccio con il cliente a livello di consulenza. Utilizzano strumenti digitali molto innovativi ed efficaci. La consiglio.", verified: true },
  { name: "Germano Bendinelli", role: "Titolare Studio Fisiomind", text: "Professionista serio, preparato e super disponibile.", verified: true },
  { name: "Emanuele Barsanti", role: "Cliente Digital Formula", text: "Professionalità e competenza. Sono molto soddisfatto del lavoro fornitomi e dell'assistenza ricevuta.", verified: true },
  { name: "Massimiliano Gallo", role: "Cliente Digital Formula", text: "Persona fantastica, disponibilità 100%, un vero professionista da consigliare.", verified: true },
  { name: "Versilia Assicurazioni", role: "Cliente Digital Formula", text: "Professionali, strumenti di marketing avanzati. Consigliato.", verified: true },
];

export const FAQS = [
  { q: "In cosa si differenzia questo percorso dagli altri sul mercato?", a: "Non \u00e8 un corso teorico. \u00c8 un percorso formativo in presenza, pratico, guidato, con il Metodo My Digital Action: un sistema collaudato per progettare e controllare la tua comunicazione digitale. Include sessioni one\u2011to\u2011one e accesso illimitato ai laboratori pratici settimanali." },
  { q: "Non ho competenze tecniche. Questo corso \u00e8 adatto a me?", a: "Assolutamente s\u00ec. Il corso \u00e8 stato pensato per imprenditori e professionisti senza background tecnico. Linguaggio semplice, metodo guidato passo passo e laboratori tecnici no\u2011code per imparare anche partendo da zero." },
  { q: "Ho poco tempo. Riuscir\u00f2 a seguirlo?", a: "S\u00ec. La formazione si svolge in una giornata in presenza (9h) per ogni modulo, tutto concreto e applicabile. In pi\u00f9, potrai continuare con coaching one\u2011to\u2011one e laboratori settimanali accessibili quando vuoi." },
  { q: "Il corso \u00e8 in presenza? Dove si svolge?", a: "S\u00ec, dal vivo presso il Campus Montacchiello (Pisa), polo tecnologico d\u2019eccellenza. Inclusa la pausa pranzo conviviale presso il ristorante Main Kitchen per favorire networking." },
  { q: "Quali metodi di pagamento sono disponibili?", a: "PayPal, carta di credito o debito. Puoi anche pagare in 3 rate senza interessi con PayPal, selezionando l\u2019opzione in fase di acquisto." },
  { q: "Cosa succede dopo l\u2019iscrizione?", a: "Ricevi subito una mail con tutte le informazioni logistiche, ricevuta, dettagli su materiali e bonus, e il calendario delle sessioni tra cui scegliere." },
  { q: "\u00c8 prevista una garanzia?", a: "S\u00ec. Garanzia Soddisfatti o Rimborsati fino alle ore 13 del giorno del corso. Se dopo la mattinata sentirai che il percorso non fa per te, potrai uscire, ricevere il rimborso completo e conservare il workbook come nostro omaggio." },
  { q: "Ho una domanda che non \u00e8 tra queste. A chi posso rivolgermi?", a: "Scrivi a info@mydigitalaction.it, contattaci via WhatsApp o Live Chat dal sito, oppure prenota una call gratuita con un nostro consulente." },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  heroBanner: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  training: "https://images.unsplash.com/photo-1758691736433-4078b93abd72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHRyYWluaW5nJTIwd29ya3Nob3B8ZW58MHx8fHwxNzg0MDA5NzQxfDA&ixlib=rb-4.1.0&q=85",
  workshop: "https://images.unsplash.com/photo-1527192491265-7e15c55b1ed2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3dvcmtpbmd8ZW58MHx8fHwxNzg0MDA5NzQ4fDA&ixlib=rb-4.1.0&q=85",
  campus: "https://images.unsplash.com/photo-1633111126270-f50f378fde68?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHx0ZWNoJTIwY2FtcHVzJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzg0MDA5NzQxfDA&ixlib=rb-4.1.0&q=85",
  francesco: "https://images.unsplash.com/photo-1640531005390-38bd92755d6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxidXNpbmVzc21hbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NDAwOTc0OHww&ixlib=rb-4.1.0&q=85",
  francesco2: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxlbnRyZXByZW5ldXIlMjBwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODQwMDk3NDF8MA&ixlib=rb-4.1.0&q=85",
};

export const TOOLS = [
  "Meta Ads", "Google Ads", "Kajabi", "GoHighLevel", "Builderall", "GetResponse", "Make", "Zapier", "ChatGPT", "Claude", "Notion", "HubSpot",
];
